import React, { useState } from 'react';

import { Button, ButtonProps } from '@mantine/core';
import { IconSparkles } from '@tabler/icons-react';
import { CreateMemoryModal } from 'pages/ManageSmartAssistant/Sections/ConversationSections/CreateMemoryButton/CreateMemoryModal/CreateMemoryModal';
import { useTranslation } from 'react-i18next';
import { Conversation } from 'shared/interfaces/Conversation';
import { SmartAssistant } from 'shared/interfaces/SmartAssistant';

interface CreateMemoryButtonProps extends ButtonProps {
  smartAssistant: SmartAssistant;
  conversation?: Conversation;
}

export function CreateMemoryButton({ conversation, smartAssistant, ...buttonProps }: CreateMemoryButtonProps) {
  const { t } = useTranslation();

  const [showCreateMemoryModal, setShowCreateMemoryModal] = useState(false);
  const closeMemoryModal = () => setShowCreateMemoryModal(false);
  const openMemoryModal = () => setShowCreateMemoryModal(true);

  return (
    <>
      <Button leftIcon={<IconSparkles />} variant="subtle" onClick={openMemoryModal} {...buttonProps}>
        {t('SMART_ASSISTANT.CONVERSATIONS_SECTION.HEADER.CREATE_MEMORY')}
      </Button>
      <CreateMemoryModal
        opened={showCreateMemoryModal}
        onClose={closeMemoryModal}
        conversation={conversation}
        smartAssistant={smartAssistant}
      />
    </>
  );
}
